import { render } from "./DoctorCard.vue?vue&type=template&id=12b3099c"
import script from "./DoctorCard.vue?vue&type=script&lang=js"
export * from "./DoctorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__